/** Lekki szkielet wierszy na czas wczytywania danych z IndexedDB. */
export function SkeletonRows({ count = 3 }: { count?: number }) {
  return (
    <div className="flex flex-col gap-2" aria-busy="true" aria-label="Ładowanie">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="h-16 animate-pulse rounded-2xl bg-stone-200/70 dark:bg-stone-800/70" />
      ))}
    </div>
  );
}
